import { useEffect, useRef } from 'react'

const FILTER_DELAY = 1500

export const useFilterWithAbort = ({
  shouldUpdate,
  handleFilter,
  onAbort,
  delay = FILTER_DELAY,
}: {
  shouldUpdate: boolean
  handleFilter: () => void
  onAbort: () => void
  delay?: number
}) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (!shouldUpdate) return
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => {
      onAbort()
      handleFilter()
    }, delay)
    return () => clearTimeout(timerRef.current || 0)
  }, [shouldUpdate, onAbort, handleFilter, delay])
}
